var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.1579L27.5375 26.6204C28.4348 25.723 29.0459 24.5797 29.2934 23.335C29.541 22.0903 29.4138 20.8001 28.9282 19.6277C28.4425 18.4552 27.62 17.4531 26.5648 16.7481C25.5096 16.043 24.2691 15.6667 23 15.6667C21.7309 15.6667 20.4904 16.043 19.4352 16.7481C18.38 17.4531 17.5575 18.4552 17.0718 19.6277C16.5862 20.8001 16.459 22.0903 16.7066 23.335C16.9541 24.5797 17.5652 25.723 18.4625 26.6204L23 31.1579ZM23 33.7503L17.1663 27.9166C16.0126 26.7628 15.2268 25.2928 14.9085 23.6925C14.5902 22.0921 14.7536 20.4333 15.378 18.9258C16.0024 17.4184 17.0599 16.1299 18.4166 15.2234C19.7733 14.3169 21.3683 13.833 23 13.833C24.6317 13.833 26.2267 14.3169 27.5834 15.2234C28.9401 16.1299 29.9976 17.4184 30.622 18.9258C31.2464 20.4333 31.4098 22.0921 31.0915 23.6925C30.7732 25.2928 29.9874 26.7628 28.8337 27.9166L23 33.7503V33.7503ZM23 23.9163C23.4862 23.9163 23.9525 23.7231 24.2964 23.3793C24.6402 23.0355 24.8333 22.5692 24.8333 22.0829C24.8333 21.5967 24.6402 21.1304 24.2964 20.7866C23.9525 20.4428 23.4862 20.2496 23 20.2496C22.5138 20.2496 22.0475 20.4428 21.7036 20.7866C21.3598 21.1304 21.1667 21.5967 21.1667 22.0829C21.1667 22.5692 21.3598 23.0355 21.7036 23.3793C22.0475 23.7231 22.5138 23.9163 23 23.9163ZM23 25.7496C22.0275 25.7496 21.0949 25.3633 20.4073 24.6757C19.7196 23.988 19.3333 23.0554 19.3333 22.0829C19.3333 21.1105 19.7196 20.1778 20.4073 19.4902C21.0949 18.8026 22.0275 18.4163 23 18.4163C23.9725 18.4163 24.9051 18.8026 25.5927 19.4902C26.2804 20.1778 26.6667 21.1105 26.6667 22.0829C26.6667 23.0554 26.2804 23.988 25.5927 24.6757C24.9051 25.3633 23.9725 25.7496 23 25.7496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3e6330cade2c4113bf533d268879cf87.svg";
export { ForwardRef as ReactComponent };